import {
  ActivityStatus,
  ActivityValueChange,
  StatusChangeActivityCard,
} from "@adsk/alloy-react-activity-log";
import React from "react";
import { IssueStatus } from "@adsk/acc-issues-types";
import { StatusText } from "@adsk/acc-issues-common/components/display/StatusText";
import { getStatusColor } from "@adsk/acc-issues-common/utils/status/statusFieldHelpers";
import { ActivityLogCardProps } from "../activityLogTypes";

const getActivityStatus = (status: IssueStatus) => ({
  text: <StatusText status={status} />,
  color: getStatusColor(status),
});

export const ChangedStatusActivityCard = ({
  activityChange,
  isAggregated,
  ...props
}: ActivityLogCardProps) => {
  const { before, after } = activityChange;
  const activityBeforeStatus = before ? getActivityStatus(before) : undefined;
  const activityAfterStatus = after
    ? getActivityStatus(after)
    : { text: "", color: "" };

  return isAggregated ? (
    <ActivityValueChange
      before={
        activityBeforeStatus && <ActivityStatus status={activityBeforeStatus} />
      }
      after={<ActivityStatus status={activityAfterStatus} />}
    />
  ) : (
    <StatusChangeActivityCard
      {...props}
      /* Used by globals.ts to amend UI issues until https://jira.autodesk.com/browse/WPLT-1164 is fixed */
      className="IssuesActivityLog__activity-card"
      beforeStatus={activityBeforeStatus}
      afterStatus={activityAfterStatus}
      data-testid="status-activity-card"
    />
  );
};
